export default __webpack_public_path__ + "static/SR USA - Safety Data Sheet - Caramel Color (Liquid)-d2c2842cdb68b766ac1cedb2588a3921.pdf";